import { cloneDeepWith } from 'lodash'

import datajson from '../data/data.json'

export interface Data {
	[key: string]: SubCategoryData
}
interface SubCategoryData {
	[key: string]: SubSubCategoryData
}
interface SubSubCategoryData {
	[key: string]: ImpactValue
}
interface ImpactValue {
	[key: string]: number
}

interface EmissionFactor {
	[key: string]: {
		impact: number
		unit: string
		description: string
	}
}

function mapImpactValues(obj: EmissionFactor): ImpactValue {
	if (!obj) return {}

	return Object.keys(obj).reduce((acc, key) => {
		acc[key] = obj[key]['impact']
		return acc
	}, {} as ImpactValue)
}

/* eslint-disable @typescript-eslint/no-explicit-any */
function convert(obj: Record<string, any>): Data {
	const newdata = cloneDeepWith(obj, value => {
		if (value.category_proxy || value.emission_factors) {
			return {
				...mapImpactValues(value.category_proxy),
				...mapImpactValues(value.emission_factors),
			}
		}
	})

	return newdata
}

function getData(): Data {
	return convert(datajson)
}

export { convert, getData }
